import { IonAccordionGroup, IonCol, IonRow } from "@ionic/react";
import { useEffect, useState } from "react";
import { makeGETRequest, makePOSTRequest } from "../../request/rawRequest";
import { Comp } from "../../types/comp";
import "../IonColor/color.css";
import BasicPage from "../baseComponents/basicPage/BasicPage";
import "../generalCSS/stylesheet.css";
import "./Competence.css";
import ThemesList from "./ThemesList";

interface ContainerProps {
  endpoint: string;
  pathLogo: string;
}

export const loadTheme = async (idComp: Array<any>): Promise<any> => {
  let themes: any = null;
  if (!idComp || idComp[0] == "") {
    return;
  }
  await makePOSTRequest("/themes", { _id: idComp }).then((response) => {
    response.sort((a: any, b: any) => a?.index - b?.index);
    themes = response;
  });
  return themes;
};

const competences = async (): Promise<Comp[]> => {
  const competences: Comp[] = [];

  await makeGETRequest(
    "/skills/technology/unique?type=" +
      localStorage.getItem("techno") +
      "&pole=" +
      localStorage.getItem("pole")
  ).then(async (response) => {
    for (let i: number = 0; i < response.length; i++) {
      competences.push({
        id: response[i]._id,
        name: response[i].name,
        themesID: Object.is(response[i].id_themes, [""])
          ? null
          : response[i].id_themes,
        index: response[i].index ?? i,
        themes: [],
      });
    }
  });

  return competences;
};

const Competence: React.FC<ContainerProps> = ({ endpoint, pathLogo }) => {
  const [compList, setCompList] = useState<Comp[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const comptemp: Promise<Comp[]> = competences();

  useEffect(() => {
    comptemp.then((response) => {
      response.map((arr, i) => {
        if (arr.name === "S1" || arr.name === "S2" || arr.name === "S3") {
          arr.themes.reverse();
        }
      });

      if (response[0]?.name.split("-")[0].replaceAll(" ", "").length === 3) {
        response.sort((a, b) =>
          a.name
            .split("-")[0]
            .replaceAll(" ", "")
            .localeCompare(b.name.split("-")[0].replaceAll(" ", ""))
        );
      }

      if (localStorage.getItem("techno") === "char") {
        response.sort((a, b) => a.index - b.index);
      }
      setCompList(response);
    });
  }, []);

  useEffect(() => {
    if (compList.length > 0) setIsLoading(false);
  }, [compList]);

  return (
    <BasicPage
      pathLogo={pathLogo}
      subtitle="Choisissez la compétence à étudier"
      title={
        localStorage.getItem("techno") === "boul"
          ? "Savoirs associés"
          : localStorage.getItem("techno") === "char"
          ? "Savoirs associés - " +
            (localStorage.getItem("pole") === "1" ? "Première" : "Deuxième") +
            " année"
          : "Technologie - Pôle " + localStorage.getItem("pole")
      }
      pathReturn="welcome"
    >
      {!isLoading && (
        <>
          <IonAccordionGroup>
            {compList.map((comp, i) => {
              return <ThemesList comp={comp} key={i} />;
            })}
          </IonAccordionGroup>

          <IonRow
            className="ion-align-items-center"
            style={{
              paddingTop: 20,
            }}
          >
            <IonCol
              hidden={
                !["pat", "char", "prim"].includes(
                  localStorage.getItem("techno") ?? ""
                )
              }
              className="ion-justify-content-end flex"
              onClick={() => {
                localStorage.setItem(
                  "pole",
                  localStorage.getItem("pole") === "1" ? "2" : "1"
                );
                window.location.reload();
              }}
            >
              <span className="btn fit-content padding ion-align-items-center">
                {getPoleLabel(
                  localStorage.getItem("techno") ?? "",
                  localStorage.getItem("pole") === "1" ? "2" : "1"
                )}
              </span>
            </IonCol>
          </IonRow>
        </>
      )}
      {isLoading && <h3>Chargement ...</h3>}
    </BasicPage>
  );
};

export default Competence;

const getPoleLabel = (techno: string, poleTo: string) => {
  switch (techno) {
    case "char":
      return "Savoirs associés " + poleTo + "° année";

    default:
      return "Technologie - Pôle " + poleTo;
  }
};
